export type InfoAgentsAction =
  | { type: 'SET_IS_FETCHING_AGENTS' }
  | { type: 'SET_IS_FETCHING_AGENTS_CONTENT' }
  | { type: 'SET_FETCH_AGENTS_FAILED' }
  | { type: 'SET_FETCH_AGENTS_CONTENT_FAILED' }
  | { type: 'SET_AGENTS', agents: Julius.Website.AgentViewModel[] }
  | { type: 'SET_AGENTS_CONTENT', content: Julius.Website.AgentsPageViewModel };

  export const setIsFetchingContent = (): InfoAgentsAction => ({
    type: 'SET_IS_FETCHING_AGENTS_CONTENT',
  });

  export const setIsFetchingAgents = (): InfoAgentsAction => ({
    type: 'SET_IS_FETCHING_AGENTS',
  });

  export const setFetchContentFailed = (): InfoAgentsAction => ({
    type: 'SET_FETCH_AGENTS_CONTENT_FAILED',
  });

  export const setFetchAgentsFailed = (): InfoAgentsAction => ({
    type: 'SET_FETCH_AGENTS_FAILED',
  });

  export const setAgentsContent = (content: Julius.Website.AgentsPageViewModel): InfoAgentsAction => ({
    content,
    type: 'SET_AGENTS_CONTENT',
  });

  export const setAgents = (agents: Julius.Website.AgentViewModel[]): InfoAgentsAction => ({
    agents,
    type: 'SET_AGENTS',
  });


// WEBPACK FOOTER //
// ./src/components/InfoAgents/Redux/actions.tsx